import React from 'react';
import { Droppable } from "react-beautiful-dnd";
import { useSelector } from 'react-redux';
import Column from './Column';

const Columns = () => {
    const staticColumns = useSelector((state)=> state.scoutKanban.columns);

    return <Droppable
        droppableId="main"
        type="column"
        direction="horizontal"
    >
        {(provided, snapshot) => (
            <div className={`row kanban-main crewContainer_main ${snapshot.isDraggingOver ? "dragging-over" : ""}`}
                ref={provided.innerRef}
                {...provided.droppableProps}>
                {staticColumns.map((column, index) => <Column key={column.columnId}
                    columnId={column.columnId}
                    scoutGroupId={column.scoutGroupId}
                    index={index}
                />)}
                {provided.placeholder}
            </div>)}
    </Droppable>;
}

export default Columns;